import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsAccessibilityClickDirective } from './abs-accessibility-click.directive';
import { AbsMessageWrapperDirective } from './abs-message-wrapper.directive';
import { AbsTrapFocusInsideElementDirective } from './abs-trap-focus-inside-element.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsAccessibilityClickDirective, AbsMessageWrapperDirective, AbsTrapFocusInsideElementDirective],
  exports:[AbsAccessibilityClickDirective, AbsMessageWrapperDirective,AbsTrapFocusInsideElementDirective],
})
export class AbsUtilitiesModule { }